'use strict';

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

/* jshint esnext: true, loopfunc: true */

var checkType = require('./type');
var numberUtils = require('./number');

var isArray = checkType.isArray;
var AP = Array.prototype;
var slice = AP.slice;

function isArrayLike(arr) {
    return (typeof arr === 'undefined' ? 'undefined' : _typeof(arr)) === 'object' && numberUtils.isFinite(arr.length);
}
function toArray(arr) {
    return isArrayLike(arr) ? slice.call(arr) : [];
}

function arrayFromSecondElement(arr) {
    return slice.call(arr, 1);
}
function applyNativeFunction(nativeFunction, target, args) {
    return nativeFunction.apply(target, arrayFromSecondElement(args));
}

// index
var index = function index(up) {
    return function (arr, searchElement, fromIndex) {
        var i = undefined;
        var len = arr.length >>> 0;
        if (len === 0) {
            return -1;
        }
        if (!fromIndex) {
            fromIndex = up ? 0 : arr.length;
        } else if (fromIndex < 0) {
            fromIndex = Math.max(0, arr.length + fromIndex);
        }
        if (up) {
            for (i = fromIndex; i < arr.length; i++) {
                if (arr[i] === searchElement) {
                    return i;
                }
            }
        } else {
            for (i = fromIndex; i >= 0; i--) {
                if (arr[i] === searchElement) {
                    return i;
                }
            }
        }
        return -1;
    };
};
var indexOf = AP.indexOf ? function (arr) {
    return applyNativeFunction(AP.indexOf, arr, arguments);
} : index(true);
var lastIndexOf = AP.lastIndexOf ? function (arr) {
    return applyNativeFunction(AP.lastIndexOf, arr, arguments);
} : index();

// each
var each = AP.forEach ? function (arr, callback, thisObj) {
    applyNativeFunction(AP.forEach, arr, arguments);
} : function (arr, callback, thisObj) {
    var a = toArray(arr);
    for (var i = 0; i < a.length; i++) {
        callback.call(thisObj, a[i], i, arr);
    }
};

// every
var every = AP.every ? function (arr) {
    return applyNativeFunction(AP.every, arr, arguments);
} : function (arr, callback, thisObj) {
    a = toArray(arr);
    for (var i = 0; i < a.length; i++) {
        if (!callback.call(thisObj, a[i], i, arr)) {
            return false;
        }
    }
    return true;
};

// filter
var filter = AP.filter ? function (arr) {
    return applyNativeFunction(AP.filter, arr, arguments);
} : function (arr, callback, thisObj) {
    var res = [];
    each(arr, function (element, key) {
        if (callback.call(thisObj, element, key, arr)) {
            res.push(element);
        }
    });
    return res;
};

// map
var map = AP.map ? function (arr) {
    return applyNativeFunction(AP.map, arr, arguments);
} : function (arr, callback, thisObj) {
    var res = [];
    each(arr, function (element, key) {
        res.push(callback.call(thisObj, element, key, arr));
    });
    return res;
};

// some
var some = AP.some ? function (arr) {
    return applyNativeFunction(AP.some, arr, arguments);
} : function (arr, callback, thisObj) {
    var i = undefined;
    for (i = 0; i < arr.length; i++) {
        if (callback.call(thisObj, arr[i], i, arr)) {
            return true;
        }
    }
    return false;
};

// reduce
var reduce = AP.reduce ? function (arr) {
    return applyNativeFunction(AP.reduce, arr, arguments);
} : function (arr, callback, thisObj) {
    var value = undefined;
    if (thisObj) {
        value = thisObj;
    }
    for (var i = 0; i < arr.length; i++) {
        if (value) {
            value = callback(value, arr[i], i, arr);
        } else {
            value = arr[i];
        }
    }
    return value;
};

// reduceRight
var reduceRight = AP.reduceRight ? function (arr) {
    return applyNativeFunction(AP.reduceRight, arr, arguments);
} : function (arr, callback, thisObj) {
    var value = undefined;
    if (thisObj) {
        value = thisObj;
    }
    for (var i = arr.length - 1; i >= 0; i--) {
        if (value) {
            value = callback(value, arr[i], i, arr);
        } else {
            value = arr[i];
        }
    }
    return value;
};

// contains
function contains(arr, value) {
    return indexOf(toArray(arr), value) > -1;
}

// uniq
function uniq(arr) {
    var resultArr = [];
    each(arr, function (element) {
        if (!contains(resultArr, element)) {
            resultArr.push(element);
        }
    });
    return resultArr;
}

// flatten
function flatten(arr) {
    var a = toArray(arr);
    var r = [];
    for (var i = 0, l = a.length; i < l; ++i) {
        if (isArrayLike(a[i])) {
            r = r.concat(a[i]);
        } else {
            r[r.length] = a[i];
        }
    }
    return r;
}

var arrayUtils = {
    contains: contains,
    each: each,
    every: every,
    filter: filter,
    flatten: flatten,
    forEach: each,
    index: index,
    indexOf: indexOf,
    isArray: isArray,
    isArrayLike: isArrayLike,
    lastIndexOf: lastIndexOf,
    map: map,
    reduce: reduce,
    reduceRight: reduceRight,
    some: some,
    toArray: toArray,
    uniq: uniq,
    difference: function difference(arr) {
        var rest = flatten(arrayFromSecondElement(arguments));
        return filter(arr, function (value) {
            return !contains(rest, value);
        });
    },
    eachReverse: function eachReverse(arr, callback, thisObj) {
        var a = toArray(arr);
        var i = a.length - 1;
        for (; i > -1; i -= 1) {
            callback.call(thisObj, a[i], i, arr);
        }
    },
    intersect: function intersect(a, b) {
        var result = [];
        each(a, function (value) {
            if (contains(b, value)) {
                result.push(value);
            }
        });
        return result;
    },
    range: function range() {
        var start = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
        var stop = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
        var step = arguments.length <= 2 || arguments[2] === undefined ? 1 : arguments[2];

        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var range = new Array(length);
        for (var i = 0; i < length; i++, start += step) {
            range[i] = start;
        }
        return range;
    },
    remove: function remove(arr, fromIndex, toIndex) {
        var rest = undefined;
        var len = arr.length;
        if (!numberUtils.isNumber(fromIndex)) {
            return arr;
        }
        rest = arr.slice((toIndex || fromIndex) + 1 || len);
        arr.length = fromIndex < 0 ? len + fromIndex : fromIndex;
        return arr.push.apply(arr, rest);
    },
    union: function union() {
        var resultArr = [];
        var sourceArrs = toArray(arguments);
        each(sourceArrs, function (arr) {
            resultArr = resultArr.concat(arr);
        });
        return uniq(resultArr);
    }
};

module.exports = arrayUtils;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-lang/array.js
 ** module id = 31
 ** module chunks = 0
 **/